import { jwtDecode } from 'jwt-decode';
import { Navigate } from 'react-router-dom';
import './pages.css';

const LoginRoute = ({ children, allowedRole, redirectTo }) => {

    const token = localStorage.getItem('token');
    if (!token) return <Navigate to={redirectTo} replace />;

    try {
        const decoded = jwtDecode(token);
        if (decoded.role !== allowedRole) throw new Error();
        return children;
    } catch {
        localStorage.removeItem('token');
        return <Navigate to={redirectTo} replace />;
    }
};

export default LoginRoute;
